export const id = 'shift2DX';
export const name = 'Shift 2D X';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: true,
    updateYDomain: false,
};
/**
 *
 * @param {Object} datum2d
 * @param {number} [shiftValue=0]
 */
export function apply(datum2D, shiftValue = 0) {
    const data = { ...datum2D.data };
    for (const key in data) {
        data[key].minX += shiftValue;
        data[key].maxX += shiftValue;
    }
}
export function isApplicable() {
    return true;
}
export function reduce(previousValue, newValue) {
    return {
        once: true,
        reduce: previousValue + newValue,
    };
}
//# sourceMappingURL=shiftX.js.map